export default "__VITE_PUBLIC_ASSET__a8356d62__"